<template>
  <div class="progress-bar">
    <div class="progress-bar__indicator" :style="progressWidth"></div>
  </div>
</template>

<script>
import { progress } from "@popmotion/popcorn";

export default {
  name: "ProgressBar",
  props: {
    max: {
      type: Number,
      default: 4
    },
    current: {
      type: Number,
      default: 0
    }
  },
  computed: {
    progressWidth: function() {
      const _progress =
        (progress(0, this.max, this.current) * 100).toString() + "%";
      return { width: _progress };
    }
  }
};
</script>

<style lang="scss" scoped>
.progress-bar {
  border-radius: sizes("border-radius");
  border: 1px solid rgba(theme-color("border"), 0.1);
  box-shadow: 0 0 10px 5px rgba(theme-color("inactive"), 0.2);
  display: block;
  height: 20px;
  position: relative;
  width: 200px;
  overflow: hidden;

  &__indicator {
    height: 100%;
    background: theme-color("gradient-loader");
    transition: cta-transition(width);
  }
}
</style>
